if (!customElements.get('mp-addon-upsell')) {
  customElements.define(
    'mp-addon-upsell',
    class MpAddonUpsell extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.addonProductId = this.dataset.addonProductId;
        this.cart = document.querySelector('cart-drawer');

        this.checkbox = this.querySelector('.mp-addon__checkbox');
        this.variantSelect = this.querySelector('.mp-addon__variants');
        this.popup = this.querySelector('.mp-addon-popup');

        if (this.popup) {
          // Escape ancestor stacking contexts so the popup can sit above the cart drawer
          document.body.appendChild(this.popup);
        }

        this._adding = false;
        this._onVariantAdd = this.onVariantAdd.bind(this);
        document.addEventListener('variant:add', this._onVariantAdd);

        this.variantSelect?.addEventListener('change', () => this.updatePrices());

        this.popup?.querySelector('.mp-addon-popup__close')?.addEventListener('click', () => this.hidePopup());
        this.popup?.querySelector('.mp-addon-popup__dismiss')?.addEventListener('click', () => this.hidePopup());
        this.popup?.querySelector('.mp-addon-popup__cta')?.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.addAddon(evt.currentTarget).then(() => this.hidePopup());
        });
      }

      disconnectedCallback() {
        document.removeEventListener('variant:add', this._onVariantAdd);
        this.popup?.remove();
      }

      get selectedVariant() {
        if (this.variantSelect) {
          const option = this.variantSelect.options[this.variantSelect.selectedIndex];
          return {
            id: this.variantSelect.value,
            price: option?.dataset.price || '',
            discounted: option?.dataset.discounted || '',
          };
        }
        return {
          id: this.dataset.variantId,
          price: this.dataset.variantPrice || '',
          discounted: this.dataset.variantDiscounted || '',
        };
      }

      get addonVariantIds() {
        return (this.dataset.variantIds || this.dataset.variantId || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);
      }

      updatePrices() {
        const variant = this.selectedVariant;
        this.querySelectorAll('[data-addon-price]').forEach((el) => (el.textContent = variant.discounted));
        this.querySelectorAll('[data-addon-compare]').forEach((el) => (el.textContent = variant.price));
      }

      onVariantAdd(evt) {
        if (this._adding) return;

        const source = String(evt.detail?.sectionId || '').replace(/-floating$/, '');
        if (source !== this.sectionId) return;

        const addedId = String(evt.detail?.variant?.id || '');
        if (this.addonVariantIds.includes(addedId)) return;

        if (this.checkbox?.checked) {
          this.addAddon();
          return;
        }

        this.maybeShowPopup();
      }

      addAddon(button) {
        const variant = this.selectedVariant;
        if (!variant.id || this._adding) return Promise.resolve();

        this._adding = true;
        button?.setAttribute('aria-disabled', 'true');

        const body = new FormData();
        body.append('id', variant.id);
        body.append('quantity', '1');
        if (this.cart) {
          body.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          body.append('sections_url', window.location.pathname);
        }

        const addUrl = window.routes?.cart_add_url || '/cart/add';

        return fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('MP addon: could not add add-on product', response.description || response.message);
              return;
            }

            if (this.cart) {
              this.cart.classList.remove('is-empty');
              this.cart.renderContents(response);
            }
            // Deliberately no cartUpdate publish here: CartDrawerItems inherits an
            // onCartUpdate that replaces the drawer with the main cart page's markup.
          })
          .catch((error) => console.error('MP addon: add to cart failed', error))
          .finally(() => {
            this._adding = false;
            button?.removeAttribute('aria-disabled');
          });
      }

      popupStorageKey() {
        return `mp-addon-popup-${this.addonProductId}`;
      }

      maybeShowPopup() {
        if (!this.popup || this.dataset.popupEnabled !== 'true') return;

        try {
          if (this.dataset.popupOnce === 'true' && sessionStorage.getItem(this.popupStorageKey())) return;
        } catch (error) {
          /* sessionStorage unavailable (e.g. private mode restrictions) — show anyway */
        }

        fetch(`${window.routes?.cart_url || '/cart'}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const alreadyInCart = (cart.items || []).some(
              (item) => String(item.product_id) === String(this.addonProductId),
            );
            if (alreadyInCart) return;

            setTimeout(() => {
              this.popup.hidden = false;
              setTimeout(() => this.popup.classList.add('is-visible'), 20);
              try {
                sessionStorage.setItem(this.popupStorageKey(), '1');
              } catch (error) {
                /* ignore */
              }
            }, 800);
          })
          .catch(() => {
            /* cart fetch failed — skip the popup rather than risk a wrong prompt */
          });
      }

      hidePopup() {
        if (!this.popup) return;
        this.popup.classList.remove('is-visible');
        setTimeout(() => (this.popup.hidden = true), 250);
      }
    },
  );
}
